const PORTFOLIO_RE = /\b(all|every|each)\s+(propert|hotel|location)|\bportfolio\b|\bacross\b[^?.!]{0,25}\b(propert|hotel|location)/i;

/**
 * Pick the single-property scope for a turn. A property explicitly resolved
 * from the user's words wins; otherwise the registered page context wins over
 * stale floating-chat state. Explicit portfolio language is never narrowed.
 */
export function resolveAssistantTurnScope({
  question,
  hotelIdOverride,
  fallbackHotelId,
  pageContext,
  accessibleIds,
}) {
  if (hotelIdOverride) return { hotelId: String(hotelIdOverride), pageScopedHotelId: null };
  if (PORTFOLIO_RE.test(String(question || ''))) return { hotelId: 'all', pageScopedHotelId: null };
  const ids = pageContext?.scope?.propertyIds || [];
  if (ids.length !== 1) return { hotelId: fallbackHotelId, pageScopedHotelId: null };
  const candidate = String(ids[0]);
  if (!accessibleIds?.has(candidate)) return { hotelId: fallbackHotelId, pageScopedHotelId: null };
  return { hotelId: candidate, pageScopedHotelId: candidate };
}

export { PORTFOLIO_RE };
